import { forEach } from "lodash";

import setLineItemWithForecastDefaultCells from "./setLineItemWithForecastDefaultCells";

const setGroupingsWithForecastDefaultCells = (
  groupings,
  columns,
  groupedByDemand,
  rootGroup,
  enableDemandRequest = false
) => {
  forEach(groupings, (grouping) => {
    forEach(grouping.lineItems, (lineItem) => {
      setLineItemWithForecastDefaultCells({
        lineItem,
        targetGroupId: groupedByDemand ? grouping.groupId : lineItem.groupId,
        sourceGroupId: groupedByDemand ? lineItem.groupId : grouping.groupId,
        columns,
        rootGroup,
        enableDemandRequest,
      });
    });

    setGroupingsWithForecastDefaultCells(
      grouping.childGroupings,
      columns,
      groupedByDemand,
      rootGroup,
      enableDemandRequest
    );
  });
};

export default setGroupingsWithForecastDefaultCells;
